<template>
    <div>
      <div class="modal hide fade" id="modalDeliveryGetProduct" tabindex="-1" role="dialog" aria-labelledby="modalGetProduct" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Product Lists</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <div class="form-inline ml-auto">
                      <select v-model="wh_no" class="btn btn-sm btn-outline-primary mr-1">
                        <option value="">---</option>
                        <option v-for="w in warehouseList" :key="w.warehouse_no" :value="w.warehouse_no">{{ w.name }}</option>
                      </select>
                      <select v-model="categoryProduct" class="btn btn-sm btn-outline-primary mr-1">
                        <option value="">--All--</option>
                        <option v-for="c in productCategoryList" :key="c.id" :value="c.id">{{ c.name }}</option>
                      </select>
                      <button class="btn btn-sm btn-outline-primary" @click="loadList"><i class="fa fa-refresh"></i></button>
                      <div class="button-group">
                        rows:
                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                          <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                        </select>
                        <span class="mr-1">
                          Total rows: <b>{{ productList.length }}</b>
                        </span>
                      </div>
                      <div class="form-group mx-sm-3 mb-2">
                          <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                      </div>
                      <span class="mr-1">
                        page:
                        <select v-model="currentPage">
                          <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                        </select>
                        / {{ pageLength }}
                      </span>
                      <nav aria-label="Page navigation example" class="pull-right">
                          <ul class="pagination">
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                                  </a>
                              </li>
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                                  </a>
                              </li>
                          </ul>
                      </nav>
                    </div>
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                            <tr>
                                <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="9" style="text-align: center;">
                              <i v-if="load"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> No Data</i>
                            </td>
                          </tr>
                            <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer" @click="select(u.id)" data-dismiss="modal">
                              <td><b>{{ u.product_no }}</b></td>
                              <td>{{ u.product_name }}</td>
                              <td>{{ u.uom_id }}</td>
                              <td>{{ u.price | currency }}</td>
                              <td>{{ u.total_gudang }}</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ priceid }}</pre>
              <pre>{{ branch }}</pre>
              <pre>{{ date }}</pre>
              <pre>{{ status }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, productUrl } from '@/config'

export default {
  name: 'SalesDeliveryModal',
  props: ['sales', 'date', 'status'],
  data () {
    return {
      load: false,
      wh_no: 'WH0001',
      categoryProduct: '',
      productList: [],
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'UoM',
        prop: 'uom_id'
      }, {
        name: 'Price',
        prop: 'price'
      }, {
        name: 'Total',
        prop: 'totalBranch'
      }],
      selectAll: false,
      selected: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      priceListGroup: state => state.priceLists.priceListGroup,
      productCategoryList: state => state.products.productCategoryList,
      warehouseList: state => state.warehouses.warehouseList,
      rowsTable: state => state.data.rowsTable
    }),
    getPrice: function () {
      var array = this.productList
      var pl = null
      for (let i = 0; i < array.length; i++) {
        pl = array[i]
      }
      return pl
    },
    pageLength: function () {
      var length = this.productList.length / this.pageSize
      return Math.ceil(length)
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.productList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async loadList () {
      this.load = true
      this.productList = []
      var date = new Date(this.date)
      date = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + (date.getDate())).slice(-2)
      var payload = {
        priceID: this.sales.price_id,
        branch: this.sales.branch_no,
        warehouse: this.wh_no,
        date: date,
        category: this.categoryProduct
      }
      console.log(payload)
      var url = productUrl + '/list'
      console.log(url)
      axios.post(url, payload, { headers: getHeader() })
        .then(response => {
          var array = response.data.data
          this.productList = array
          this.load = false
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.productList.length) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select: function (id) {
      var product = this.productList.find(d => d.id === id)
      console.log(this.status)
      console.log(product)
      if (this.status === 'service') {
        this.$emit('selectProductService', product)
      } else {
        this.$emit('selectProduct', product)
      }
    }
  },
  mounted () {
    // this.loadList()
  }
}
</script>
